import React from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'
import Plumber from 'Assets/Icons/doodle_liquidity.png'
import Plus from 'Assets/Icons/doodle_plus.png'
import Minus from 'Assets/Icons/doodle_minus.png'
import Temple from 'Assets/Icons/doodle_temple.png'
import Staking from 'Assets/Icons/doodle_staking.png'

import './Liquidity.scss'

const Liquidity: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <div className="Liquidity">
      <div className="Liquidity__header">
        <img src={Plumber} alt="Liquidity" />
        <span>
          <h1>{t('liquidity.title')}</h1>
          <p>{t('liquidity.p-1')}</p>
          <p>
            <Trans i18nKey="for-more-info-press-here">
              For more information press{' '}
              <a
                href="https://unifiprotocol.zendesk.com/hc/en-us"
                title="more information"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
              .
            </Trans>
          </p>
        </span>
      </div>

      <div className="Liquidity__selectors">
        <span
          className="Liquidity__selectors__selector"
          onClick={() => history.push('/liquidity/pool')}
        >
          <div>
            <img src={Plus} alt="Add Liquidity" />
          </div>
          <div className="selector__title">{t('liquidity.join-pool')}</div>
        </span>
        <span
          className="Liquidity__selectors__selector"
          onClick={() => history.push('/liquidity/remove-pool')}
        >
          <div>
            <img src={Minus} alt="Remove Liquidity" />
          </div>
          <div className="selector__title">
            {t('liquidity.withdraw-liquidity')}
          </div>
        </span>
        <span
          className="Liquidity__selectors__selector"
          onClick={() => history.push('/farms')}
        >
          <div>
            <img src={Temple} alt="Claim UP" />
          </div>
          <div className="selector__title">
            {t('liquidity.claim-up-rewards')}
          </div>
        </span>
        <span
          className="Liquidity__selectors__selector"
          onClick={() => window.open('https://gov.unifiprotocol.com/')}
        >
          <div>
            <img src={Staking} alt="Stake UNFI" />
          </div>
          <div className="selector__title">{t('liquidity.stake-unfi')}</div>
        </span>
      </div>
    </div>
  )
}

export { Liquidity }
